// src/admin/ChatbotManager.js - New component to manage all chatbot conversations
import React, { useState, useEffect } from 'react';
import { database as db } from '../firebaseConfig';
import { ref, onValue } from "firebase/database";
import './ChatbotManager.css'; // Optional: Create this CSS file for styling

const ChatbotManager = () => {
  const [conversations, setConversations] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [isSidebarMini, setIsSidebarMini] = useState(false); // State cho mini/full sidebar

  useEffect(() => {
    const chatsRef = ref(db, 'chats');
    const unsubscribe = onValue(chatsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setConversations(data);
      }
    });

    return () => unsubscribe();
  }, []);

  // Detect mobile và set mặc định mini
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsSidebarMini(mediaQuery.matches); // Mini nếu mobile

    const handleResize = (e) => {
      setIsSidebarMini(e.matches);
    };

    mediaQuery.addEventListener('change', handleResize);
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  const handleSelectUser = (userId) => {
    setSelectedUser(userId);
    // Không đóng sidebar nữa vì luôn visible
  };

  const toggleSidebar = () => {
    setIsSidebarMini(!isSidebarMini);
  };

  const renderSidebar = () => {
    const sidebarClass = isSidebarMini ? 'chatbot-manager-mini' : 'chatbot-manager-full';
    const toggleIcon = isSidebarMini ? '>>' : '<<'; // Icon thay đổi

    return (
      <aside className={`chatbot-manager-sidebar ${sidebarClass}`}>
        <h2>
          <span className="chatbot-manager-sidebar-title">Danh sách người dùng</span>
          <button className="chatbot-manager-toggle-button" onClick={toggleSidebar}>
            {toggleIcon}
          </button>
        </h2>
        <ul>
          {Object.keys(conversations).map((userId) => (
            <li 
              key={userId} 
              onClick={() => handleSelectUser(userId)}
              className={selectedUser === userId ? 'active' : ''}
            >
              {userId.substring(0, 15)}... ({Object.keys(conversations[userId]).length} tin nhắn)
            </li>
          ))}
        </ul>
      </aside>
    );
  };

  const renderConversation = () => {
    if (!selectedUser) {
      return (
        <div className="chatbot-manager-no-selection">
          <p>Vui lòng chọn một người dùng từ danh sách bên trái để xem cuộc trò chuyện.</p>
        </div>
      );
    }

    const userConversations = conversations[selectedUser] || {};
    const messages = Object.values(userConversations).sort((a, b) => a.timestamp - b.timestamp);

    return (
      <div className="chatbot-manager-conversation">
        <h2>Cuộc trò chuyện của người dùng {selectedUser.substring(0, 8)}...</h2>
        <div className="messages">
          {messages.map((msg, index) => (
            <div key={index} className={`message ${msg.sender} ${msg.sender === 'bot' && msg.type ? `bot-${msg.type}` : ''}`}>
              <div className="message-header">
                <span className="timestamp">{new Date(msg.timestamp).toLocaleString()}</span>
                {msg.sender === 'bot' && msg.type && (
                  <span className="response-type">{msg.type.toUpperCase()}</span>
                )}
              </div>
              <p>{msg.text}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="chatbot-manager">
      <h1>Quản lý Chatbot</h1>
      <div className="chatbot-manager-layout">
        {renderSidebar()}
        <main className="chatbot-manager-main">
          {renderConversation()}
        </main>
      </div>
    </div>
  );
};

export default ChatbotManager;